import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Swiper as SwiperReact, SwiperProps } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';

export const swiperStyle = css`
  && {
    user-select: none;

    .swiper-slide {
      &:last-of-type {
        margin-right: 0;
      }
    }

    @media (--only-tablet) {
      width: auto;
      padding-right: calc((100vw - 660px) / 2);
      padding-left: calc((100vw - 660px) / 2);
      margin-right: calc((-100vw + 660px) / 2);
      margin-left: calc((-100vw + 660px) / 2);
    }

    @media (--only-mobile) {
      width: auto;
      padding-right: 16px;
      padding-left: 16px;
      margin-right: -16px;
      margin-left: -16px;
    }
  }
`;

export const Swiper = ({ className, ...rest }: SwiperProps) => (
  <SwiperReact className={cn(swiperStyle, className)} {...rest} />
);
